import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      size: "medium",
      stripe: "",
      data: _ctx.users,
      style: {"width":"100%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          align: "center",
          label: "#ID",
          width: "60"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_tooltip, {
              content: scope.row._id
            }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createElementVNode("i", { class: "el-icon-user" }, null, -1)
              ]))]),
              _: 1
            }, 8, ["content"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "firstName",
          label: "First Name",
          width: "180"
        }),
        _createVNode(_component_el_table_column, {
          prop: "lastName",
          label: "Last Name",
          width: "180"
        }),
        _createVNode(_component_el_table_column, {
          align: "center",
          label: "User Type",
          width: "170"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_tag, {
              type: 
              scope.row.type === 'admin'
                ? 'danger'
                : scope.row.type === 'talent'
                ? 'info'
                : 'success'
            ,
              effect: "dark",
              "is-rounded": "",
              size: "mini"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$filters.capitalize(scope.row.type)), 1)
              ]),
              _: 2
            }, 1032, ["type"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Email",
          width: "330"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_link, {
              type: "primary",
              href: `mailto:${scope.row.email}`,
              size: "mini"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(scope.row.email), 1)
              ]),
              _: 2
            }, 1032, ["href"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          align: "center",
          label: "Is Active",
          width: "130"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_switch, {
              "model-value": scope.row.isActive,
              size: "mini"
            }, null, 8, ["model-value"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          align: "center",
          label: "Verified Email",
          width: "130"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_switch, {
              "model-value": scope.row.verifiedEmail,
              size: "mini"
            }, null, 8, ["model-value"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          align: "center",
          label: "Reset Score",
          width: "130"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_tooltip, { content: "Resets the survey score of this user." }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  icon: "el-icon-refresh",
                  "is-borderless": "",
                  plain: "",
                  size: "mini",
                  onClick: ($event: any) => (_ctx.resetScore(scope.row._id))
                }, {
                  default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                    _createTextVNode(" Reset ", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          align: "center",
          label: "Actions"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              icon: "el-icon-more",
              type: "primary",
              "is-borderless": "",
              circle: "",
              plain: "",
              size: "mini"
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading]
    ])
  ]))
}